import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// In development: Actively unregister any old Service Workers
if (process.env.NODE_ENV !== 'production' && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    if (registrations.length > 0) {
      console.log('🧹 Found', registrations.length, 'old Service Worker(s), unregistering...');
      registrations.forEach((registration) => {
        registration.unregister().then(() => {
          console.log('✅ Unregistered Service Worker:', registration.scope);
        });
      });
      // Clear caches as well
      if ('caches' in window) {
        caches.keys().then((cacheNames) => {
          return Promise.all(
            cacheNames.map((cacheName) => {
              console.log('🗑️ Deleting cache:', cacheName);
              return caches.delete(cacheName);
            })
          );
        }).then(() => {
          console.log('✅ All caches cleared');
        });
      }
    } else {
      console.log('✅ No Service Workers to clean up');
    }
  });
}

// Register Service Worker for PWA - only in production
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js', { updateViaCache: 'none' })
      .then((registration) => {
        registration.update();
        console.log('✅ PWA: Service Worker registered successfully:', registration.scope);
      })
      .catch((error) => {
        console.log('❌ PWA: Service Worker registration failed:', error);
      });
  });
}
